import { render, staticRenderFns } from "./RgObjectDetailItem.vue?vue&type=template&id=c3b97496&scoped=true&"
import script from "./RgObjectDetailItem.vue?vue&type=script&lang=js&"
export * from "./RgObjectDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./RgObjectDetailItem.vue?vue&type=style&index=0&id=c3b97496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b97496",
  null
  
)

export default component.exports